import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const CashFlow = () => {
  const getTop = async (selectedYears) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    let filter = { FYs: _selectedYears };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/cashflow/${company_id}/${company_org_id}/topdata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getMiddle = async (dimDate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedDimDate = dimDate.slice();
    let filter = { DimDateKey: _selectedDimDate };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/cashflow/${company_id}/${company_org_id}/middledata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getBottom = async (selectedYears) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    let filter = { FYs: _selectedYears };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/cashflow/${company_id}/${company_org_id}/bottomdata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };
  return {
    getTop,
    getMiddle,
    getBottom,
  };
};

export default CashFlow();
